import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Icon } from '@codex-brightworld/icons';

const Wrapper = styled.ul`
  margin: 0;
  padding: 0;
  font-size: 13px;
`;

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  padding-left: 0;
  list-style: none;

  ${({
    theme
  }) => css`
    margin: 0 0 ${theme.spacing[2]};
  `}

  &:last-child {
    margin-bottom: 0;
  }

  ${Icon} {
    margin: -3px 2px 4px -3px;
    width: 20px;
    flex-shrink: 0;
  }
`;

/**
 * @tags styled, list, items
 */
function List(props) {
  return (
    <Wrapper {...props} data-qa={props.qa}>
      {props.items.map((item, index) => props.children(item, index, Item))}
    </Wrapper>
  );
}

List.displayName = 'List';

List.propTypes = {
  /**
   * Item renderer.
   *
   * @param {mixed} item
   * @param {number} index
   * @param {Item} ItemWrapper
   * @return {React.Node}
   */
  children: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  qa: PropTypes.string
};

List.defaultProps = {
  children: (item, index, ItemWrapper) => (
    <ItemWrapper key={index}>
      <Icon icon="tick" /> <span dangerouslySetInnerHTML={{ __html: item }} />
    </ItemWrapper>
  ),
  qa: undefined
};

/** @component */
export default List;
